if (!window.Promise) require('@babel/polyfill')

var scriptEl = document.getElementById('insided-app')
if (scriptEl) {
  var basePath = scriptEl.getAttribute('data-basepath')
  if (basePath) {
    __webpack_public_path__ = basePath.replace(/\/js\/$/, '/') // eslint-disable-line
  }
}
require('./app.js')
